import { render, staticRenderFns } from "./otherapply.vue?vue&type=template&id=5243cc24&scoped=true"
import script from "./otherapply.vue?vue&type=script&lang=js"
export * from "./otherapply.vue?vue&type=script&lang=js"
import style0 from "./otherapply.vue?vue&type=style&index=0&id=5243cc24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5243cc24",
  null
  
)

export default component.exports